// extracted by mini-css-extract-plugin
module.exports = {"responsiveImgContainer":"responsive-image_responsiveImgContainer__AlbZ8"};